import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';
import topBox from './topBox';

const twoColumnsList: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',

  maxWidth: 'calc(100vw - 10px)',

  mx: 'auto',
  gap: spacing(3),
  px: 3,

  overflow: 'hidden',
  height: '100vh',
  '.requiredFilter__Border': {
    borderLeftStyle: 'solid !important',
    borderLeftWidth: '4px !important',
    borderLeftColor: 'palette.error.main',
  },

  '.twoColumnsList__topBox': topBox,

  '&.maximized': {
    '.twoColumnsList__section': {
      '.twoColumnsList__aside': {
        display: 'none',
      },
    },
    '.twoColumnsList__topBox': {
      '.topBox__heading': {
        '.topBox__nav': {
          display: 'flex',
          '.HamburguerIconWrapper': {
            display: responsive({ 0: 'none', 3: 'flex' }),
          },
        },
      },
    },
  },

  '.twoColumnsList__section': {
    display: 'flex',
    gap: spacing(3),
    alignItems: 'stretch',
    flexGrow: 1,
    overflow: 'hidden',

    '.twoColumnsList__main': {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      height: '100%',
      overflow: 'hidden',
      maxHeight: '100%',
      padding: '4px',
      pt: 0,

      '.twoColumnsList__content ': {
        flexGrow: 1,
        flexShrink: 100,
        overflow: 'auto',
        maxHeight: '100%',
        background: 'palette.background.paper',
        boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
        borderRadius: 'default',
        ':has(.container)': {
          borderRadius: '8px',
          border: '1px solid',
          borderColor: 'palette.gray.750',
          overflow: 'hidden',
          boxShadow: 'none',
        },

        '.selection__keyHandler': {
          height: '100%',

          '.responsiveTable__wrapper': {
            height: '100%',
          },
        },
      },

      '.twoColumnsList__contentFooter': {
        flexShrink: 0,
        flexGrow: 0,
      },

      '#AccordionAside': {
        display: responsive({ 0: 'block', 3: 'none' }),
        overflow: 'hidden',
        '.asidePanel__content': {
          paddingTop: spacing(3),
        },
        '.content': {
          background: 'palette.background.paper',
          overflow: ' auto',

          '.ApplicationMenu': {
            mx: 'auto',
            // py: responsive({ 0: 4, 2: 7 }),
            // px: responsive({ 0: 4, 2: 0 }),
          },
        },
        '.twoColumns__main__bodyAside.accordionElement': {
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '100%',
        },
      },
    },

    '.twoColumnsList__aside': {
      width: 'applicationMenu',
      flexShrink: 0,
      flexGrow: 0,
      overflow: 'auto',
      maxHeight: '100%',
      pr: spacing(2),

      display: responsive({ 0: 'none', 4: 'flex' }),
      flexDirection: 'column',

      alignItems: 'stretch',
      justifyContent: 'stretch',

      '& > div': {
        height: '100%',

        '.ApplicationMenu': {
          height: '100%',
        },
      },
    },
  },
};

export default twoColumnsList;
